module.exports = __webpack_public_path__ + "static/media/Event-Carousels-Adventure.4893cec3.webp";